import { useMemo } from "react";
import { useParams } from "react-router";
import { ICommunicationsRequestParams } from "shared";

import { useFetchCommunicationsQuery } from "../services/api/communicationsApi/communicationsApi";

interface UseCommunicationsOptions {
  contactId?: number;
  inboxType?: ICommunicationsRequestParams[`inboxType`];
}

export function useCommunications(options: UseCommunicationsOptions = {}) {
  const { contactId, organisationId } = useParams<{ contactId?: string; organisationId?: string }>();
  const selectedContactId = useMemo(() => {
    if (typeof options.contactId === `number`) {
      return options.contactId;
    }

    return contactId ? Number(contactId) : undefined;
  }, [contactId, options.contactId]);

  const params: ICommunicationsRequestParams = {
    contactId: selectedContactId,
    page: 1,
    pageSize: 100,
    inboxType: options.inboxType,
  };

  const result = useFetchCommunicationsQuery({
    ...params,
    organisationId,
  }, {
    skip: !organisationId,
    pollingInterval: 30000, // Poll every 30 seconds
    skipPollingIfUnfocused: true,
  });

  result.data = result.data || { communications: [] };

  return result;
}
